// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topbar-wrap {
  background-color: #fff;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 20px;
  box-shadow: 10px 0px 10px 0px rgba(0, 0, 0, 0.1);
}
.topbar-wrap .profile-btn {
  border: none;
  padding: 2px;
  border-radius: 10px;
  background: #fff;
  width: 40px;
  height: 40px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
}
.topbar-wrap .profile-btn .img-wrap {
  width: 36px;
  height: 36px;
  overflow: hidden;
  border-radius: 8px;
  font-size: 35px;
  font-weight: 700;
}
.topbar-wrap .profile-btn .img-wrap img {
  max-width: 36px;
  height: auto;
}

::ng-deep .profile-menu.p-menu {
  border: none;
}
::ng-deep .profile-menu.p-menu.p-menu-overlay {
  padding: 5px 0px;
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
}
::ng-deep .profile-menu.p-menu .p-menuitem-separator {
  border: 1px solid #eeeeee;
}
::ng-deep .profile-menu.p-menu .p-menuitem .p-menuitem-content .p-menuitem-link {
  font-size: 14px !important;
  font-weight: 500;
  padding: 12px 20px;
  justify-content: space-between;
}
::ng-deep .profile-menu.p-menu .p-menuitem .p-menuitem-content .p-menuitem-link .p-menuitem-text {
  transition: all ease 0.3s;
}
::ng-deep .profile-menu.p-menu .p-menuitem .p-menuitem-content:hover {
  background-color: #ebf8ff !important;
}
::ng-deep .profile-menu.p-menu .p-menuitem .p-menuitem-content:hover .p-menuitem-link .p-menuitem-text,
::ng-deep .profile-menu.p-menu .p-menuitem .p-menuitem-content:hover .p-menuitem-link .p-menuitem-icon {
  color: #0482c5 !important;
}
::ng-deep .profile-menu.p-menu .p-menuitem.p-focus .p-menuitem-content, ::ng-deep .profile-menu.p-menu .p-menuitem.active-menuitem .p-menuitem-content {
  background-color: #ebf8ff !important;
}
::ng-deep .profile-menu.p-menu .p-menuitem.p-focus .p-menuitem-content .p-menuitem-link .p-menuitem-text, ::ng-deep .profile-menu.p-menu .p-menuitem.active-menuitem .p-menuitem-content .p-menuitem-link .p-menuitem-text {
  color: #0482c5 !important;
}
::ng-deep .profile-menu.p-menu .p-menuitem.logout-link .p-menuitem-link .p-menuitem-text {
  color: #777;
}
::ng-deep .profile-menu.p-menu .p-menuitem.logout-link .p-menuitem-link .p-menuitem-icon {
  color: #777;
  order: 1;
  margin-right: 0px;
  width: unset;
}

.topbar-wrap .visible-sm {
  display: none;
}

@media screen and (max-width: 699px) {
  .topbar-wrap {
    justify-content: space-between;
  }
  .topbar-wrap .visible-sm {
    display: block;
  }
  .topbar-wrap .visible-sm img {
    height: 50px;
    width: auto;
  }
  ::ng-deep .p-paginator {
    height: unset;
  }
  ::ng-deep .p-paginator .p-paginator-current {
    margin-right: 0px;
  }
  ::ng-deep .p-paginator .p-inputwrapper {
    margin-left: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/admin/src/app/components/widgets/topbar/topbar.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gDAAA;AACF;AACE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AACN;AAAM;EACE,eAAA;EACA,YAAA;AAER;;AAIA;EACE,YAAA;AADF;AAGE;EACE,gBAAA;EACA,mBAAA;EACA,+CAAA;AADJ;AAGE;EACE,yBAAA;AADJ;AAKM;EACE,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;AAHR;AAKQ;EACE,yBAAA;AAHV;AAOM;EACE,oCAAA;AALR;AAMQ;;EAEE,yBAAA;AAJV;AAWM;EACE,oCAAA;AATR;AAUQ;EACE,yBAAA;AARV;AAeQ;EACE,WAAA;AAbV;AAeQ;EACE,WAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AAbV;;AAoBA;EACE,aAAA;AAjBF;;AAoBA;EACE;IACE,8BAAA;EAjBF;EAmBE;IACE,cAAA;EAjBJ;EAmBI;IACE,YAAA;IACA,WAAA;EAjBN;EAsBA;IACE,aAAA;EApBF;EAsBE;IACE,iBAAA;EApBJ;EAuBE;IACE,gBAAA;EArBJ;AACF","sourcesContent":[".topbar-wrap {\n  background-color: #fff;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 15px 20px;\n  box-shadow: 10px 0px 10px 0px rgba(0, 0, 0, 0.1);\n\n  .profile-btn {\n    border: none;\n    padding: 2px;\n    border-radius: 10px;\n    background: #fff;\n    width: 40px;\n    height: 40px;\n    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);\n\n    .img-wrap {\n      width: 36px;\n      height: 36px;\n      overflow: hidden;\n      border-radius: 8px;\n      font-size: 35px;\n      font-weight: 700;\n      img {\n        max-width: 36px;\n        height: auto;\n      }\n    }\n  }\n}\n\n::ng-deep .profile-menu.p-menu {\n  border: none;\n\n  &.p-menu-overlay {\n    padding: 5px 0px;\n    border-radius: 10px;\n    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);\n  }\n  .p-menuitem-separator {\n    border: 1px solid #eeeeee;\n  }\n  .p-menuitem {\n    .p-menuitem-content {\n      .p-menuitem-link {\n        font-size: 14px !important;\n        font-weight: 500;\n        padding: 12px 20px;\n        justify-content: space-between;\n\n        .p-menuitem-text {\n          transition: all ease 0.3s;\n        }\n      }\n\n      &:hover {\n        background-color: #ebf8ff !important;\n        .p-menuitem-link .p-menuitem-text,\n        .p-menuitem-link .p-menuitem-icon {\n          color: #0482c5 !important;\n        }\n      }\n    }\n\n    &.p-focus,\n    &.active-menuitem {\n      .p-menuitem-content {\n        background-color: #ebf8ff !important;\n        .p-menuitem-link .p-menuitem-text {\n          color: #0482c5 !important;\n        }\n      }\n    }\n\n    &.logout-link {\n      .p-menuitem-link {\n        .p-menuitem-text {\n          color: #777;\n        }\n        .p-menuitem-icon {\n          color: #777;\n          order: 1;\n          margin-right: 0px;\n          width: unset;\n        }\n      }\n    }\n  }\n}\n\n.topbar-wrap .visible-sm {\n  display: none;\n}\n\n@media screen and (max-width: 699px) {\n  .topbar-wrap {\n    justify-content: space-between;\n\n    .visible-sm {\n      display: block;\n\n      img {\n        height: 50px;\n        width: auto;\n      }\n    }\n  }\n\n  ::ng-deep .p-paginator {\n    height: unset;\n\n    .p-paginator-current {\n      margin-right: 0px;\n    }\n\n    .p-inputwrapper {\n      margin-left: 0px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
